import { Tabs } from "antd";
import React from "react";
import type { TabsProps } from "antd";
import classes from "./Documentation.module.css";
import { Accounts } from "./Settings/Accounts";
import { Password } from "./Settings/Password";
import { Credits } from "./Settings/Credits";
import {
	CreditCardOutlined,
	UserOutlined,
	KeyOutlined,
} from "@ant-design/icons";
import { useNavigation, useRouterContext } from "@refinedev/core";

const items: TabsProps["items"] = [
	{
		key: "account",
		label: (
			<div>
				<UserOutlined
					style={{
						marginRight: "8px",
					}}
				/>{" "}
				ACCOUNT
			</div>
		),
		children: <Accounts />,
	},
	{
		key: "credits",
		label: (
			<div>
				<CreditCardOutlined
					style={{
						marginRight: "8px",
					}}
				/>
				CREDITS
			</div>
		),
		children: <Credits />,
	},
	{
		key: "password",
		label: (
			<div>
				<KeyOutlined
					style={{
						marginRight: "8px",
					}}
				/>
				PASSWORD
			</div>
		),
		children: <Password />,
	},
];

export const Documentation = () => {
	const { useParams } = useRouterContext();
	const { push } = useNavigation();

	const params = useParams<any>();

	const onChange = (key: string) => {
		push("/settings/" + key);
	};

	return (
		<Tabs
			defaultActiveKey="1"
			activeKey={`${params?.setting}`}
			centered
			items={items}
			onChange={onChange}
			className={classes.tabs}
			style={{ outline: "none" }}
		/>
	);
};
